import { IDuTypeFormValueType } from "../Types/duTypeFormProps"
import { IDuTypeError } from "./IDuTypeFormField"

export interface IInitialStateDuType {
  values: IDuTypeFormValueType
  errors: IDuTypeError
  submitted: boolean
  dirty: boolean
  setPopup: boolean
  isFormValid: boolean
}

export const iInitialStateDuType: IInitialStateDuType = {
  values: {
    containerType: "",
    containerName: "",
    description: "",
    //customerType:"",
    // legacyContainerName:"",
    // legacyContainerType:"",
    // legacyDescription:"",
    legacyContainerDetails: null,
    linkedContainers: null,
    weight: null,
    volume: null,
    fullLength: null,
    fullWidth: null,
    fullHeight: null,
    weightCap: null,
    minPickVolume: null,
    maxPickVolume: null,
    lpIndicator: false,
    mlpIndicator: false,
    muIndicator: false,
    isLinkableContainer: false,
    legacyContainerHasValue:false
  },
  errors: {
    containerType: "",
    containerName: "",
    description: "",
    //customerType: "",
    // legacyContainerName:"",
    // legacyContainerType:"",
    // legacyDescription:"",
    weight: "",
    volume: "",
    fullLength: "",
    fullWidth: "",
    fullHeight: "",
    weightCap: "",
    minPickVolume: "",
    maxPickVolume: "",
    lpIndicator: "",
    mlpIndicator: "",
    muIndicator: "",
    isLinkableContainer: "",
    legacyContainerHasValue:""
  },
  submitted: false,
  dirty: false,
  setPopup: false,
  isFormValid: false
}